import React from 'react'
import { useTranslation } from 'react-i18next'
import bannerDivImg from '../../../assets/img/banner-div.svg'
import logoTextLargeImg from '../../../assets/img/logo-text-large.svg'
import './style.scss'

const Banner: React.FC = () => {
  const { t } = useTranslation('trans', { keyPrefix: 'banner' })

  return (
    <div id="banner">
      <div className="width-container">
        <div className="logo-text">
          <img src={logoTextLargeImg} alt="" />
        </div>
        <div className="div">
          <img src={bannerDivImg} alt="" />
        </div>
        <div className="desc">{t('description')}</div>
      </div>
    </div>
  )
}

export default Banner
